$(document).ready(function(){

  $('.search-modal__wrapper').click(function() {
    $('#idOnePredictive').attr("open", true);
    $('.search__input_predictive').attr("aria-expanded", true);
    console.log('yes')
  });
  
 //  DarkMode
 //    let box_occa = localStorage.getItem('themeMode');
 //    $('html').attr('data-scheme' , box_occa)
  
 //    $(".header__toggle-scheme-item--dark").click(function () {
 //        localStorage.removeItem('themeMode');
 //        var HTML_occasion = 'dark'
 //        $('html').attr('data-scheme' , 'dark')
 //        localStorage.setItem('themeMode', HTML_occasion);     
	// });
 //    $(".header__toggle-scheme-item--light").click(function () {
 //        localStorage.removeItem('themeMode');
 //        $('html').attr('data-scheme' , 'light')
 //        var HTML_occasion = 'light'
 //        localStorage.setItem('themeMode', HTML_occasion);     
	// });
localStorage.removeItem('themeMode')
  
  // MetaTab
  $('li.description').click(function(){
    $(this).addClass('tab_heading_active').siblings().removeClass('tab_heading_active');
    $('.description').addClass('tab_active').siblings().removeClass('tab_active');
  });
  $('li.technicial_specs').click(function(){
    $(this).addClass('tab_heading_active').siblings().removeClass('tab_heading_active');
    $('.technicial_specs').addClass('tab_active').siblings().removeClass('tab_active');
  });
  $('li.extended_information').click(function(){
    $(this).addClass('tab_heading_active').siblings().removeClass('tab_heading_active');
    $('.extended_information').addClass('tab_active').siblings().removeClass('tab_active');
  });

});

// var ThemeColor = localStorage.getItem('themeColor')
// document.querySelector('html').setAttribute('data-scheme' , ThemeColor)

// var ThemeColor = {
//   theme_1 : "dark",
//   theme_2 : "light",
// }

// function ThemeMode_1(){
//    localStorage.removeItem('themeColor')
//    document.querySelector('html').setAttribute('data-scheme' , ThemeColor.theme_1)
//    localStorage.setItem('themeColor', ThemeColor.theme_1)
// }
// function ThemeMode_2(){
//    localStorage.removeItem('themeColor')
//    document.querySelector('html').setAttribute('data-scheme' , ThemeColor.theme_2)
//    localStorage.setItem('themeColor', ThemeColor.theme_2)
// }
localStorage.removeItem('themeColor')